export const setItem = (key: string, value: string): void => {
  sessionStorage.setItem(key, value);
};

export const getItem = (key: string): any => {
  return sessionStorage.getItem(key);
};

export const removeItem = (key: string): void => {
  sessionStorage.removeItem(key);
};

export const setSavedStateItem = (sessionStorageKey: string, state: any, replacer?: (number | string)[]): void => {
  sessionStorage.setItem(sessionStorageKey, JSON.stringify(state, replacer));
};

export const getSavedStateItem = (sessionStorageKey: string): any => {
  return JSON.parse(sessionStorage.getItem(sessionStorageKey) as string);
};

export const existsItem = (sessionStorageKey: string): boolean => {
  if (sessionStorage.getItem(sessionStorageKey)) {
    return true;
  } else {
    return false;
  }
};
